import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import { CompagnieFormValues } from './CompagnieFormValues';
import { compagnieValidationRules } from './compagnieValidationRules';

const compagnieFormConfig = createFormConfig<CompagnieFormValues>(
  compagnieValidationRules as ValidationRules<keyof CompagnieFormValues>,
  {
    [AddressFormFieldNames.Country]: 'FR'
  }
);

export { compagnieFormConfig };
